
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Tabs from './tabs'
import Tab from './tab'
import TabList from './tab-list'
import TabItem from './tab-item'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "tabs"
    }}>{`Tabs`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "tabs-1"
    }}>{`Tabs`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For navigating between related sections of content within a single context.`}</p>
    <Playground __position={1} __code={'<Tabs>\n  <Tab id=\"tab1\" title=\"Tab item 1\">\n    <p style={{ margin: \'1rem 0\' }}>Tab 1 content</p>\n  </Tab>\n  <Tab id=\"tab2\" title=\"Tab item 2\" defaultSelected>\n    <div style={{ margin: \'1rem 0\' }}>Tab 2 content</div>\n  </Tab>\n  <Tab id=\"tab3\" title=\"Tab item 3\">\n    <div style={{ margin: \'1rem 0\' }}>Tab 3 content</div>\n  </Tab>\n</Tabs>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tabs,
      Tab,
      TabList,
      TabItem
    }} mdxType="Playground">
  <Tabs mdxType="Tabs">
    <Tab id='tab1' title='Tab item 1' mdxType="Tab">
      <p style={{
            margin: '1rem 0'
          }}>Tab 1 content</p>
    </Tab>
    <Tab id='tab2' title='Tab item 2' defaultSelected mdxType="Tab">
      <div style={{
            margin: '1rem 0'
          }}>Tab 2 content</div>
    </Tab>
    <Tab id='tab3' title='Tab item 3' mdxType="Tab">
      <div style={{
            margin: '1rem 0'
          }}>Tab 3 content</div>
    </Tab>
  </Tabs>
    </Playground>
    <hr />
    <h2 {...{
      "id": "tabs-minor"
    }}>{`Tabs (minor)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For navigating between related sections of content within a single context.`}</p>
    <Playground __position={3} __code={'<Tabs minor>\n  <Tab id=\"taba\" title=\"Tab item A\">\n    <p style={{ margin: \'1rem 0\' }}>Tab A content</p>\n  </Tab>\n  <Tab id=\"tabb\" title=\"Tab item B\">\n    <p style={{ margin: \'1rem 0\' }}>Tab B content</p>\n  </Tab>\n  <Tab id=\"tabc\" title=\"Tab item C\">\n    <p style={{ margin: \'1rem 0\' }}>Tab C content</p>\n  </Tab>\n  <Tab id=\"tabd\" title=\"Tab item D\">\n    <p style={{ margin: \'1rem 0\' }}>Tab D content</p>\n  </Tab>\n</Tabs>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tabs,
      Tab,
      TabList,
      TabItem
    }} mdxType="Playground">
  <Tabs minor mdxType="Tabs">
    <Tab id='taba' title='Tab item A' mdxType="Tab">
      <p style={{
            margin: '1rem 0'
          }}>Tab A content</p>
    </Tab>
    <Tab id='tabb' title='Tab item B' mdxType="Tab">
      <p style={{
            margin: '1rem 0'
          }}>Tab B content</p>
    </Tab>
    <Tab id='tabc' title='Tab item C' mdxType="Tab">
      <p style={{
            margin: '1rem 0'
          }}>Tab C content</p>
    </Tab>
    <Tab id='tabd' title='Tab item D' mdxType="Tab">
      <p style={{
            margin: '1rem 0'
          }}>Tab D content</p>
    </Tab>
  </Tabs>
    </Playground>
    <hr />
    <h2 {...{
      "id": "tabs-adjacent"
    }}>{`Tabs (adjacent)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For navigating between related sections of content within a single context.`}</p>
    <p><strong parentName="p">{`The adjacent prop sets the layout on small screens to stack items vertically instead of horizonatally.`}</strong></p>
    <Playground __position={5} __code={'<Tabs adjacent>\n  <Tab id=\"tab1\" title=\"Tab item 1\">\n    <div style={{ margin: \'1rem 0\' }}>Tab 1 content</div>\n  </Tab>\n  <Tab id=\"tab2\" title=\"Tab item 2\">\n    <div style={{ margin: \'1rem 0\' }}>Tab 2 content</div>\n  </Tab>\n</Tabs>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tabs,
      Tab,
      TabList,
      TabItem
    }} mdxType="Playground">
  <Tabs adjacent mdxType="Tabs">
    <Tab id='tab1' title='Tab item 1' mdxType="Tab">
      <div style={{
            margin: '1rem 0'
          }}>Tab 1 content</div>
    </Tab>
    <Tab id='tab2' title='Tab item 2' mdxType="Tab">
      <div style={{
            margin: '1rem 0'
          }}>Tab 2 content</div>
    </Tab>
  </Tabs>
    </Playground>
    <hr />
    <h2 {...{
      "id": "tabs-minor-adjacent"
    }}>{`Tabs (minor, adjacent)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For navigating between related sections of content within a single context.`}</p>
    <p><strong parentName="p">{`The adjacent prop sets the layout on small screens to stack items vertically instead of horizonatally.`}</strong></p>
    <Playground __position={7} __code={'<Tabs minor adjacent>\n  <Tab id=\"tab1\" title=\"Tab item 1\">\n    <div style={{ margin: \'1rem 0\' }}>Tab 1 content</div>\n  </Tab>\n  <Tab id=\"tab2\" title=\"Tab item 2\">\n    <div style={{ margin: \'1rem 0\' }}>Tab 2 content</div>\n  </Tab>\n</Tabs>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tabs,
      Tab,
      TabList,
      TabItem
    }} mdxType="Playground">
  <Tabs minor adjacent mdxType="Tabs">
    <Tab id='tab1' title='Tab item 1' mdxType="Tab">
      <div style={{
            margin: '1rem 0'
          }}>Tab 1 content</div>
    </Tab>
    <Tab id='tab2' title='Tab item 2' mdxType="Tab">
      <div style={{
            margin: '1rem 0'
          }}>Tab 2 content</div>
    </Tab>
  </Tabs>
    </Playground>
    <hr />
    <h2 {...{
      "id": "tabslist-and-tabitem"
    }}>{`TabsList and TabItem`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`Without `}<inlineCode parentName="p">{`Tab`}</inlineCode>{` content; for navigating between different links, pages or sections.`}</p>
    <p><strong parentName="p">{`When a series of links is needed for custom navigation or without the need to hide/show content.`}<inlineCode parentName="strong">{`TabItem`}</inlineCode>{` selection is controlled manually.`}</strong></p>
    <Playground __position={9} __code={'<TabList>\n  <TabItem href=\"#test1\" title=\"Tab item 1\" />\n  <TabItem href=\"#test2\" title=\"Tab item 2\" selected />\n  <TabItem href=\"#test3\" title=\"Tab item 3\" />\n</TabList>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tabs,
      Tab,
      TabList,
      TabItem
    }} mdxType="Playground">
  <TabList mdxType="TabList">
    <TabItem href="#test1" title='Tab item 1' mdxType="TabItem" />
    <TabItem href="#test2" title='Tab item 2' selected mdxType="TabItem" />
    <TabItem href="#test3" title='Tab item 3' mdxType="TabItem" />
  </TabList>
    </Playground>
    <hr />
    <h2 {...{
      "id": "tabslist-and-tabitem-adjacent-minor"
    }}>{`TabsList and TabItem (adjacent, minor)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`Without `}<inlineCode parentName="p">{`Tab`}</inlineCode>{` content; for navigating between different links, pages or sections.`}</p>
    <p><strong parentName="p">{`When a series of links is needed for custom navigation or without the need to hide/show content.`}<inlineCode parentName="strong">{`TabItem`}</inlineCode>{` selection is controlled manually.`}</strong></p>
    <Playground __position={11} __code={'<TabList adjacent>\n  <TabItem minor href=\"#test1\" title=\"Tab item 1\" />\n  <TabItem minor href=\"#test2\" title=\"Tab item 2\" selected />\n  <TabItem minor href=\"#test3\" title=\"Tab item 3\" />\n</TabList>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Tabs,
      Tab,
      TabList,
      TabItem
    }} mdxType="Playground">
  <TabList adjacent mdxType="TabList">
    <TabItem minor href="#test1" title='Tab item 1' mdxType="TabItem" />
    <TabItem minor href="#test2" title='Tab item 2' selected mdxType="TabItem" />
    <TabItem minor href="#test3" title='Tab item 3' mdxType="TabItem" />
  </TabList>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Tabs} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;